// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as LoginRouteRouteImport } from './routes/_login/route'
import { Route as _mainRouteRouteImport } from './routes/__main/route'
import { Route as AdvertiserMainRouteRouteImport } from './routes/advertiser/_main/route'
import { Route as AdvertiserLoginRouteRouteImport } from './routes/advertiser/_login/route'
import { Route as AdvertiserBlankRouteRouteImport } from './routes/advertiser/_blank/route'
import { Route as AdvertiserAssistantRouteRouteImport } from './routes/advertiser/_assistant/route'
import { Route as DashboardWatchlistRouteImport } from './routes/dashboard/watchlist'
import { Route as DashboardUserRouteImport } from './routes/dashboard/user'
import { Route as DashboardPasswordRouteImport } from './routes/dashboard/password'
import { Route as DashboardMapsApiUsageRouteImport } from './routes/dashboard/maps-api-usage'
import { Route as DashboardInquiriesRouteImport } from './routes/dashboard/inquiries'
import { Route as LoginSignUpRouteImport } from './routes/_login/sign-up'
import { Route as LoginSignInRouteImport } from './routes/_login/sign-in'
import { Route as LoginResetPasswordRouteImport } from './routes/_login/reset-password'
import { Route as LoginForgotPasswordRouteImport } from './routes/_login/forgot-password'
import { Route as _mainIndexRouteImport } from './routes/__main/index'
import { Route as _mainLocaleRouteRouteImport } from './routes/__main/$locale/route'
import { Route as AdvertiserMainIndexRouteImport } from './routes/advertiser/_main/index'
import { Route as AdvertiserMainUserRouteImport } from './routes/advertiser/_main/user'
import { Route as AdvertiserMainPasswordRouteImport } from './routes/advertiser/_main/password'
import { Route as AdvertiserMainLocationsRouteImport } from './routes/advertiser/_main/locations'
import { Route as AdvertiserMainInquiriesRouteImport } from './routes/advertiser/_main/inquiries'
import { Route as AdvertiserMainBillingRouteImport } from './routes/advertiser/_main/billing'
import { Route as AdvertiserLoginSignInRouteImport } from './routes/advertiser/_login/sign-in'
import { Route as AdvertiserLoginResetPasswordRouteImport } from './routes/advertiser/_login/reset-password'
import { Route as AdvertiserLoginForgotPasswordRouteImport } from './routes/advertiser/_login/forgot-password'
import { Route as AdvertiserBlankSignUpRouteImport } from './routes/advertiser/_blank/sign-up'
import { Route as AdvertiserAssistantAddLocationRouteImport } from './routes/advertiser/_assistant/add-location'
import { Route as _mainLocationIdRouteImport } from './routes/__main/location/$id'
import { Route as _mainLocaleIndexRouteImport } from './routes/__main/$locale/index'
import { Route as _mainLocaleSignUpRouteImport } from './routes/__main/$locale/sign-up'
import { Route as _mainLocaleSignInRouteImport } from './routes/__main/$locale/sign-in'
import { Route as _mainLocaleSearchRouteImport } from './routes/__main/$locale/search'
import { Route as _mainLocaleResetPasswordRouteImport } from './routes/__main/$locale/reset-password'
import { Route as _mainLocaleForgotPasswordRouteImport } from './routes/__main/$locale/forgot-password'
import { Route as _mainLocaleSplatRouteImport } from './routes/__main/$locale/$'
import { Route as AdvertiserAssistantEditLocationIdRouteImport } from './routes/advertiser/_assistant/edit-location.$id'
import { Route as _mainLocaleLocationIdRouteImport } from './routes/__main/$locale/location/$id'
import { Route as _mainCategorySlugLocationIdTabRouteImport } from './routes/__main/$category/$slug/$locationId/$tab'
import { Route as _mainLocaleCategorySlugLocationIdTabRouteImport } from './routes/__main/$locale/$category/$slug/$locationId/$tab'

const AdvertiserRouteImport = createFileRoute('/advertiser')()

const AdvertiserRoute = AdvertiserRouteImport.update({
            id: '/advertiser',path: '/advertiser',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const LoginRouteRoute = LoginRouteRouteImport.update({
            id: '/_login',getParentRoute: () => rootRouteImport
          })
const _mainRouteRoute = _mainRouteRouteImport.update({
            id: '/__main',getParentRoute: () => rootRouteImport
          })
const AdvertiserMainRouteRoute = AdvertiserMainRouteRouteImport.update({
            id: '/_main',getParentRoute: () => AdvertiserRoute
          })
const AdvertiserLoginRouteRoute = AdvertiserLoginRouteRouteImport.update({
            id: '/_login',getParentRoute: () => AdvertiserRoute
          })
const AdvertiserBlankRouteRoute = AdvertiserBlankRouteRouteImport.update({
            id: '/_blank',getParentRoute: () => AdvertiserRoute
          })
const AdvertiserAssistantRouteRoute = AdvertiserAssistantRouteRouteImport.update({
            id: '/_assistant',getParentRoute: () => AdvertiserRoute
          })
const DashboardWatchlistRoute = DashboardWatchlistRouteImport.update({
            id: '/watchlist',path: '/watchlist',getParentRoute: () => DashboardRouteRoute
          })
const DashboardUserRoute = DashboardUserRouteImport.update({
            id: '/user',path: '/user',getParentRoute: () => DashboardRouteRoute
          })
const DashboardPasswordRoute = DashboardPasswordRouteImport.update({
            id: '/password',path: '/password',getParentRoute: () => DashboardRouteRoute
          })
const DashboardMapsApiUsageRoute = DashboardMapsApiUsageRouteImport.update({
            id: '/maps-api-usage',path: '/maps-api-usage',getParentRoute: () => DashboardRouteRoute
          })
const DashboardInquiriesRoute = DashboardInquiriesRouteImport.update({
            id: '/inquiries',path: '/inquiries',getParentRoute: () => DashboardRouteRoute
          })
const LoginSignUpRoute = LoginSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => LoginRouteRoute
          })
const LoginSignInRoute = LoginSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => LoginRouteRoute
          })
const LoginResetPasswordRoute = LoginResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => LoginRouteRoute
          })
const LoginForgotPasswordRoute = LoginForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => LoginRouteRoute
          })
const _mainIndexRoute = _mainIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _mainRouteRoute
          })
const _mainLocaleRouteRoute = _mainLocaleRouteRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => _mainRouteRoute
          })
const AdvertiserMainIndexRoute = AdvertiserMainIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdvertiserMainRouteRoute
          })
const AdvertiserMainUserRoute = AdvertiserMainUserRouteImport.update({
            id: '/user',path: '/user',getParentRoute: () => AdvertiserMainRouteRoute
          })
const AdvertiserMainPasswordRoute = AdvertiserMainPasswordRouteImport.update({
            id: '/password',path: '/password',getParentRoute: () => AdvertiserMainRouteRoute
          })
const AdvertiserMainLocationsRoute = AdvertiserMainLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => AdvertiserMainRouteRoute
          })
const AdvertiserMainInquiriesRoute = AdvertiserMainInquiriesRouteImport.update({
            id: '/inquiries',path: '/inquiries',getParentRoute: () => AdvertiserMainRouteRoute
          })
const AdvertiserMainBillingRoute = AdvertiserMainBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AdvertiserMainRouteRoute
          })
const AdvertiserLoginSignInRoute = AdvertiserLoginSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AdvertiserLoginRouteRoute
          })
const AdvertiserLoginResetPasswordRoute = AdvertiserLoginResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AdvertiserLoginRouteRoute
          })
const AdvertiserLoginForgotPasswordRoute = AdvertiserLoginForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AdvertiserLoginRouteRoute
          })
const AdvertiserBlankSignUpRoute = AdvertiserBlankSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AdvertiserBlankRouteRoute
          })
const AdvertiserAssistantAddLocationRoute = AdvertiserAssistantAddLocationRouteImport.update({
            id: '/add-location',path: '/add-location',getParentRoute: () => AdvertiserAssistantRouteRoute
          })
const _mainLocationIdRoute = _mainLocationIdRouteImport.update({
            id: '/location/$id',path: '/location/$id',getParentRoute: () => _mainRouteRoute
          })
const _mainLocaleIndexRoute = _mainLocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainLocaleSignUpRoute = _mainLocaleSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainLocaleSignInRoute = _mainLocaleSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainLocaleSearchRoute = _mainLocaleSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainLocaleResetPasswordRoute = _mainLocaleResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainLocaleForgotPasswordRoute = _mainLocaleForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainLocaleSplatRoute = _mainLocaleSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => _mainLocaleRouteRoute
          })
const AdvertiserAssistantEditLocationIdRoute = AdvertiserAssistantEditLocationIdRouteImport.update({
            id: '/edit-location/$id',path: '/edit-location/$id',getParentRoute: () => AdvertiserAssistantRouteRoute
          })
const _mainLocaleLocationIdRoute = _mainLocaleLocationIdRouteImport.update({
            id: '/location/$id',path: '/location/$id',getParentRoute: () => _mainLocaleRouteRoute
          })
const _mainCategorySlugLocationIdTabRoute = _mainCategorySlugLocationIdTabRouteImport.update({
            id: '/$category/$slug/$locationId/$tab',path: '/$category/$slug/$locationId/$tab',getParentRoute: () => _mainRouteRoute
          })
const _mainLocaleCategorySlugLocationIdTabRoute = _mainLocaleCategorySlugLocationIdTabRouteImport.update({
            id: '/$category/$slug/$locationId/$tab',path: '/$category/$slug/$locationId/$tab',getParentRoute: () => _mainLocaleRouteRoute
          })





const _mainLocaleRouteRouteChildren = {
  _mainLocaleSplatRoute: _mainLocaleSplatRoute,_mainLocaleForgotPasswordRoute: _mainLocaleForgotPasswordRoute,_mainLocaleResetPasswordRoute: _mainLocaleResetPasswordRoute,_mainLocaleSearchRoute: _mainLocaleSearchRoute,_mainLocaleSignInRoute: _mainLocaleSignInRoute,_mainLocaleSignUpRoute: _mainLocaleSignUpRoute,_mainLocaleIndexRoute: _mainLocaleIndexRoute,_mainLocaleLocationIdRoute: _mainLocaleLocationIdRoute,_mainLocaleCategorySlugLocationIdTabRoute: _mainLocaleCategorySlugLocationIdTabRoute
}

const _mainLocaleRouteRouteWithChildren = _mainLocaleRouteRoute._addFileChildren(_mainLocaleRouteRouteChildren)



const _mainRouteRouteChildren = {
  _mainLocaleRouteRoute: _mainLocaleRouteRouteWithChildren,_mainIndexRoute: _mainIndexRoute,_mainLocationIdRoute: _mainLocationIdRoute,_mainCategorySlugLocationIdTabRoute: _mainCategorySlugLocationIdTabRoute
}

const _mainRouteRouteWithChildren = _mainRouteRoute._addFileChildren(_mainRouteRouteChildren)




const LoginRouteRouteChildren = {
  LoginForgotPasswordRoute: LoginForgotPasswordRoute,LoginResetPasswordRoute: LoginResetPasswordRoute,LoginSignInRoute: LoginSignInRoute,LoginSignUpRoute: LoginSignUpRoute
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(LoginRouteRouteChildren)




const DashboardRouteRouteChildren = {
  DashboardInquiriesRoute: DashboardInquiriesRoute,DashboardMapsApiUsageRoute: DashboardMapsApiUsageRoute,DashboardPasswordRoute: DashboardPasswordRoute,DashboardUserRoute: DashboardUserRoute,DashboardWatchlistRoute: DashboardWatchlistRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)




const AdvertiserAssistantRouteRouteChildren = {
  AdvertiserAssistantAddLocationRoute: AdvertiserAssistantAddLocationRoute,AdvertiserAssistantEditLocationIdRoute: AdvertiserAssistantEditLocationIdRoute
}

const AdvertiserAssistantRouteRouteWithChildren = AdvertiserAssistantRouteRoute._addFileChildren(AdvertiserAssistantRouteRouteChildren)




const AdvertiserBlankRouteRouteChildren = {
  AdvertiserBlankSignUpRoute: AdvertiserBlankSignUpRoute
}

const AdvertiserBlankRouteRouteWithChildren = AdvertiserBlankRouteRoute._addFileChildren(AdvertiserBlankRouteRouteChildren)




const AdvertiserLoginRouteRouteChildren = {
  AdvertiserLoginForgotPasswordRoute: AdvertiserLoginForgotPasswordRoute,AdvertiserLoginResetPasswordRoute: AdvertiserLoginResetPasswordRoute,AdvertiserLoginSignInRoute: AdvertiserLoginSignInRoute
}

const AdvertiserLoginRouteRouteWithChildren = AdvertiserLoginRouteRoute._addFileChildren(AdvertiserLoginRouteRouteChildren)




const AdvertiserMainRouteRouteChildren = {
  AdvertiserMainBillingRoute: AdvertiserMainBillingRoute,AdvertiserMainInquiriesRoute: AdvertiserMainInquiriesRoute,AdvertiserMainLocationsRoute: AdvertiserMainLocationsRoute,AdvertiserMainPasswordRoute: AdvertiserMainPasswordRoute,AdvertiserMainUserRoute: AdvertiserMainUserRoute,AdvertiserMainIndexRoute: AdvertiserMainIndexRoute
}

const AdvertiserMainRouteRouteWithChildren = AdvertiserMainRouteRoute._addFileChildren(AdvertiserMainRouteRouteChildren)



const AdvertiserRouteChildren = {
  AdvertiserAssistantRouteRoute: AdvertiserAssistantRouteRouteWithChildren,AdvertiserBlankRouteRoute: AdvertiserBlankRouteRouteWithChildren,AdvertiserLoginRouteRoute: AdvertiserLoginRouteRouteWithChildren,AdvertiserMainRouteRoute: AdvertiserMainRouteRouteWithChildren
}

const AdvertiserRouteWithChildren = AdvertiserRoute._addFileChildren(AdvertiserRouteChildren)

const rootRouteChildren = {
  _mainRouteRoute: _mainRouteRouteWithChildren,LoginRouteRoute: LoginRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRouteWithChildren,AdvertiserRoute: AdvertiserRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)